import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ApiService, SubscriptionSink } from '@app/shared';

@Component({
  selector: 'app-user-layout',
  templateUrl: './user-layout.component.html',
  styleUrls: ['./user-layout.component.scss']
})
export class UserLayoutComponent implements OnInit, OnDestroy {

  videoUrl: SafeUrl | null = null;

  isLoading = false;

  protected subscription = new SubscriptionSink();

  constructor(protected sanitizer: DomSanitizer, protected api: ApiService) { }

  ngOnInit(): void {
    this.subscription.sink = this.api.active$.subscribe(active => {
      this.isLoading = active;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  setVideo(id: string) {
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${id}?rel=0&autoplay=1`);
  }

}
